module.exports = __webpack_public_path__ + "static/media/complexPic4.c87bdb48.png";